export const videos = [
  {
    id: "xinghe-jiuyuan",
    title: "星河救援",
    type: "movie",
    year: 2024,
    region: "中国",
    genres: ["科幻", "动作"],
    rating: 8.7,
    director: "陈立群",
    actors: ["张远", "李梦", "周航"],
    status: "已上映",
    episodes: "HD",
    updateDate: "2024-09-18",
    views: 12870000,
    synopsis:
      "近未来，一场突如其来的星际风暴切断了空间站的通讯。救援船船员临危受命，穿越陨石带前往失联空间站，在有限的时间里展开一场与时间赛跑的高空营救，也重新理解了责任与信任的意义。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20key%20art%2C%20futuristic%20rescue%20spaceship%20hovering%20above%20a%20glowing%20blue%20planet%2C%20lone%20astronaut%20silhouette%2C%20starry%20deep%20space%20nebula%20background%2C%20dramatic%20lighting%2C%20rich%20color%20grading%2C%20professional%20film%20poster%2C%20high%20detail&width=400&height=600&seq=vid-01-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20space%20scene%2C%20rescue%20spaceship%20flying%20past%20a%20glowing%20planet%20with%20a%20distant%20space%20station%2C%20starry%20nebula%20and%20cosmic%20dust%2C%20dramatic%20blue%20and%20amber%20lighting%2C%20epic%20film%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-01-back&orientation=landscape",
    featured: true,
  },
  {
    id: "miwu-zhuixiong",
    title: "迷雾追凶",
    type: "movie",
    year: 2023,
    region: "中国",
    genres: ["悬疑", "犯罪"],
    rating: 8.2,
    director: "王海",
    actors: ["赵岩", "周琳"],
    status: "已上映",
    episodes: "HD",
    updateDate: "2024-03-12",
    views: 8600000,
    synopsis:
      "一桩十二年前的悬案因一封匿名信重新浮出水面。老刑警带着年轻搭档穿行在雨夜的城市街头，透过层层迷雾追查真相，也逐渐触及自己尘封已久的往事。",
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20thriller%20poster%20key%20art%2C%20rain-soaked%20city%20street%20at%20night%2C%20detective%20silhouette%20under%20a%20flickering%20street%20lamp%2C%20thick%20fog%20and%20neon%20reflections%2C%20moody%20cinematic%20lighting%2C%20desaturated%20tones%2C%20professional%20film%20poster%2C%20high%20detail&width=400&height=600&seq=vid-02-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20noir%20city%20street%20at%20night%20in%20heavy%20rain%2C%20foggy%20alley%20with%20cold%20street%20lamps%20and%20reflections%2C%20mysterious%20atmosphere%2C%20cinematic%20thriller%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-02-back&orientation=landscape",
    featured: false,
  },
  {
    id: "dushi-yeguiren",
    title: "都市夜归人",
    type: "movie",
    year: 2024,
    region: "中国",
    genres: ["剧情", "爱情"],
    rating: 7.9,
    director: "李思远",
    actors: ["孙宁", "吴晴"],
    status: "已上映",
    episodes: "HD",
    updateDate: "2024-10-02",
    views: 5400000,
    synopsis:
      "两个在深夜城市里各自奔忙的年轻人，因为一次偶然的错拿外卖而相识。从陌生到熟悉，他们在灯火通明的街头，慢慢找到了属于自己的那份温柔。",
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20drama%20poster%20key%20art%2C%20young%20office%20worker%20walking%20through%20a%20glowing%20city%20street%20at%20night%2C%20warm%20street%20lights%20and%20reflective%20wet%20pavement%2C%20soft%20cinematic%20bokeh%2C%20emotional%20atmosphere%2C%20professional%20film%20poster%2C%20high%20detail&width=400&height=600&seq=vid-03-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20city%20street%20at%20night%20with%20glowing%20shop%20lights%20and%20soft%20bokeh%2C%20lone%20figure%20walking%20on%20wet%20pavement%2C%20gentle%20cinematic%20urban%20mood%2C%20high%20detail&width=1280&height=720&seq=vid-03-back&orientation=landscape",
    featured: true,
  },
  {
    id: "jisu-bianjing",
    title: "极速边境",
    type: "movie",
    year: 2024,
    region: "美国",
    genres: ["动作", "犯罪"],
    rating: 8.0,
    director: "大卫·米勒",
    actors: ["马克·李", "艾米·沃森"],
    status: "已上映",
    episodes: "HD",
    updateDate: "2024-08-21",
    views: 9900000,
    synopsis:
      "一名退役赛车手被卷入一场横跨边境的追捕行动。为了洗清冤屈，他驾驶着改装战车，在沙漠公路上与时间、与追兵展开一场惊心动魄的极速较量。",
    cover:
      "https://readdy.ai/api/search-image?query=Action%20movie%20poster%20key%20art%2C%20muscle%20car%20drifting%20on%20a%20desert%20highway%20at%20sunset%2C%20dust%20clouds%20and%20motion%20blur%2C%20explosive%20orange%20and%20amber%20sky%2C%20dynamic%20cinematic%20composition%2C%20professional%20film%20poster%2C%20high%20detail&width=400&height=600&seq=vid-04-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20desert%20highway%20at%20sunset%20with%20a%20speeding%20muscle%20car%20and%20trailing%20dust%2C%20dramatic%20orange%20sky%20and%20canyon%20silhouettes%2C%20high%20energy%20cinematic%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-04-back&orientation=landscape",
    featured: true,
  },
  {
    id: "shenhai-zhiguang",
    title: "深海之光",
    type: "movie",
    year: 2023,
    region: "英国",
    genres: ["科幻", "悬疑"],
    rating: 8.5,
    director: "奥利弗·班克斯",
    actors: ["凯特·哈德森", "卢克·贝里"],
    status: "已上映",
    episodes: "HD",
    updateDate: "2024-01-15",
    views: 7600000,
    synopsis:
      "一支深海科考队在探索未知海沟时，捕捉到一束无法解释的微光。随着下潜越深，队员们的记忆开始出现奇怪的断层，真相藏在最深的海底。",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20sci-fi%20poster%20key%20art%2C%20deep%20ocean%20trench%20with%20a%20faint%20blue%20light%20beam%2C%20submarine%20silhouette%2C%20dark%20water%20and%20floating%20particles%2C%20eerie%20cinematic%20lighting%2C%20professional%20film%20poster%2C%20high%20detail&width=400&height=600&seq=vid-05-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20deep%20ocean%20scene%20with%20a%20glowing%20blue%20light%20in%20dark%20water%2C%20small%20submersible%20descending%20into%20the%20trench%2C%20eerie%20cinematic%20underwater%20atmosphere%2C%20high%20detail&width=1280&height=720&seq=vid-05-back&orientation=landscape",
    featured: false,
  },
  {
    id: "dongjing-zhixia",
    title: "东京之夏",
    type: "movie",
    year: 2024,
    region: "日本",
    genres: ["爱情", "剧情"],
    rating: 8.1,
    director: "小林健",
    actors: ["佐藤遥", "中村绫"],
    status: "已上映",
    episodes: "HD",
    updateDate: "2024-07-30",
    views: 4300000,
    synopsis:
      "在东京的一个炎热夏天，两位素未谋面的年轻人在一间旧书店相遇。一次关于旧唱片的闲聊，开启了一段短暂却深刻的夏日情缘。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20film%20poster%20key%20art%2C%20young%20couple%20on%20a%20Tokyo%20street%20in%20summer%2C%20warm%20bokeh%20lanterns%20and%20soft%20golden%20evening%20light%2C%20tender%20emotional%20atmosphere%2C%20professional%20film%20poster%2C%20high%20detail&width=400&height=600&seq=vid-06-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20Tokyo%20street%20in%20summer%20twilight%20with%20warm%20lanterns%20and%20glowing%20signs%2C%20soft%20golden%20light%2C%20romantic%20cinematic%20urban%20atmosphere%2C%20high%20detail&width=1280&height=720&seq=vid-06-back&orientation=landscape",
    featured: true,
  },
  {
    id: "zuihou-mima",
    title: "最后的密码",
    type: "movie",
    year: 2022,
    region: "美国",
    genres: ["悬疑", "动作"],
    rating: 7.6,
    director: "杰克·雷诺兹",
    actors: ["山姆·科林", "娜塔莎·里德"],
    status: "已上映",
    episodes: "HD",
    updateDate: "2023-11-08",
    views: 6200000,
    synopsis:
      "一枚在博物馆尘封多年的密码机突然重新启动，随之而来的是一连串神秘的解密挑战。一位数学天才被卷入其中，必须在倒计时结束前破解最后的密码。",
    cover:
      "https://readdy.ai/api/search-image?query=Suspense%20thriller%20poster%20key%20art%2C%20encrypted%20code%20glowing%20on%20a%20dark%20monitor%2C%20a%20hand%20reaching%20toward%20the%20screen%2C%20dramatic%20rim%20light%2C%20cool%20cyan%20tones%2C%20mysterious%20atmosphere%2C%20professional%20film%20poster%2C%20high%20detail&width=400&height=600&seq=vid-07-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20dark%20high-tech%20room%20filled%20with%20glowing%20cyan%20code%20on%20screens%2C%20mysterious%20cinematic%20lighting%2C%20thriller%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-07-back&orientation=landscape",
    featured: false,
  },
  {
    id: "shannabian-de-feng",
    title: "山那边的风",
    type: "movie",
    year: 2023,
    region: "中国",
    genres: ["家庭", "剧情"],
    rating: 8.4,
    director: "何东",
    actors: ["刘桂芳", "陈小雨"],
    status: "已上映",
    episodes: "HD",
    updateDate: "2024-05-19",
    views: 3100000,
    synopsis:
      "在城市打拼多年的女儿回到山村老家，陪伴年迈的父亲度过一个安静的秋天。一场关于理解与和解的旅程，就在山风与炊烟之间缓缓展开。",
    cover:
      "https://readdy.ai/api/search-image?query=Family%20drama%20poster%20key%20art%2C%20rural%20mountain%20village%20at%20golden%20hour%2C%20a%20parent%20and%20child%20on%20a%20winding%20path%2C%20rolling%20green%20hills%20and%20warm%20sunlight%2C%20gentle%20emotional%20tone%2C%20professional%20film%20poster%2C%20high%20detail&width=400&height=600&seq=vid-08-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20terraced%20mountain%20village%20at%20golden%20hour%2C%20winding%20path%20and%20warm%20sunlight%20over%20green%20hills%2C%20peaceful%20cinematic%20countryside%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-08-back&orientation=landscape",
    featured: false,
  },
  {
    id: "changan-yanyun",
    title: "长安烟云录",
    type: "tv",
    year: 2024,
    region: "中国",
    genres: ["历史", "古装"],
    rating: 9.0,
    director: "吴宇",
    actors: ["韩雪", "林峰", "徐正"],
    status: "已完结",
    episodes: "全40集",
    updateDate: "2024-09-30",
    views: 21500000,
    synopsis:
      "盛世长安之下，暗流涌动。一位出身寒门的年轻官员在朝堂与市井之间周旋，凭着一份赤诚与智慧，在风云变幻的时代里守护心中的公道。",
    cover:
      "https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20poster%20key%20art%2C%20ancient%20palace%20rooftops%20in%20golden%20mist%2C%20a%20robed%20figure%20overlooking%20the%20city%2C%20ornate%20lanterns%20and%20silk%20banners%2C%20epic%20cinematic%20lighting%2C%20professional%20drama%20poster%2C%20high%20detail&width=400&height=600&seq=vid-09-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20ancient%20Chinese%20capital%20city%20at%20dusk%20with%20layered%20palace%20roofs%2C%20lanterns%20and%20golden%20mist%2C%20epic%20historical%20cinematic%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-09-back&orientation=landscape",
    featured: true,
  },
  {
    id: "chenmo-de-zhengci",
    title: "沉默的证词",
    type: "tv",
    year: 2024,
    region: "中国",
    genres: ["犯罪", "悬疑"],
    rating: 8.6,
    director: "郭强",
    actors: ["黄磊", "谭静", "赵磊"],
    status: "连载中",
    episodes: "更新至18集",
    updateDate: "2024-10-10",
    views: 8900000,
    synopsis:
      "一位善于观察细节的法医，与一名沉默寡言的老刑警组成搭档。他们通过一具具无声的“证词”，抽丝剥茧，还原被掩盖的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=Crime%20drama%20poster%20key%20art%2C%20dim%20interrogation%20room%20with%20a%20single%20overhead%20lamp%2C%20detective%20and%20suspect%20silhouettes%2C%20cold%20grey%20tones%20and%20deep%20shadows%2C%20tense%20cinematic%20atmosphere%2C%20professional%20drama%20poster%2C%20high%20detail&width=400&height=600&seq=vid-10-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20moody%20police%20office%20at%20night%20with%20case%20files%20and%20cold%20lighting%2C%20tense%20cinematic%20crime%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-10-back&orientation=landscape",
    featured: false,
  },
  {
    id: "wangguo-bianyuan",
    title: "王国边缘",
    type: "tv",
    year: 2023,
    region: "美国",
    genres: ["奇幻", "冒险"],
    rating: 8.3,
    director: "艾琳·卡特",
    actors: ["托马斯·格雷", "索菲亚·贝尔"],
    status: "已完结",
    episodes: "全10集",
    updateDate: "2024-02-20",
    views: 11200000,
    synopsis:
      "在王国与荒原的交界处，一位被放逐的骑士发现了关于王位继承的古老秘密。为了守护家园，他必须重拾信念，踏上一条充满魔法与危险的道路。",
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20series%20poster%20key%20art%2C%20a%20lone%20knight%20on%20a%20cliff%20facing%20a%20vast%20castle%20under%20stormy%20skies%2C%20epic%20dramatic%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20professional%20fantasy%20poster%2C%20high%20detail&width=400&height=600&seq=vid-11-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20fantasy%20landscape%20with%20a%20vast%20castle%20under%20stormy%20dramatic%20skies%2C%20lone%20knight%20on%20a%20cliff%2C%20epic%20cinematic%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-11-back&orientation=landscape",
    featured: false,
  },
  {
    id: "shouer-zhixin",
    title: "首尔之心",
    type: "tv",
    year: 2024,
    region: "韩国",
    genres: ["爱情", "都市"],
    rating: 8.0,
    director: "金明秀",
    actors: ["李瑞妍", "朴志勋"],
    status: "连载中",
    episodes: "更新至12集",
    updateDate: "2024-10-08",
    views: 6700000,
    synopsis:
      "一位开着小咖啡店的姑娘，与一名常来深夜加班的建筑师，在首尔的街头相遇。两段各自疲惫的人生，因一杯热咖啡而慢慢靠近。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20K-drama%20poster%20key%20art%2C%20stylish%20young%20couple%20on%20a%20Seoul%20street%20at%20dusk%2C%20city%20lights%20and%20warm%20bokeh%2C%20soft%20cinematic%20glow%2C%20modern%20elegant%20atmosphere%2C%20professional%20drama%20poster%2C%20high%20detail&width=400&height=600&seq=vid-12-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20Seoul%20street%20at%20dusk%20with%20warm%20city%20lights%20and%20a%20cozy%20cafe%2C%20soft%20romantic%20cinematic%20atmosphere%2C%20high%20detail&width=1280&height=720&seq=vid-12-back&orientation=landscape",
    featured: false,
  },
  {
    id: "daima-fengbao",
    title: "代码风暴",
    type: "tv",
    year: 2024,
    region: "美国",
    genres: ["科技", "悬疑"],
    rating: 8.8,
    director: "诺亚·布莱克",
    actors: ["埃里克·肖", "米娅·陈"],
    status: "已完结",
    episodes: "全8集",
    updateDate: "2024-06-14",
    views: 5300000,
    synopsis:
      "一家科技公司发布的新系统出现了无法解释的漏洞。年轻的白帽工程师在排查过程中，发现这并非简单的故障，而是一场精心策划的阴谋。",
    cover:
      "https://readdy.ai/api/search-image?query=Tech%20thriller%20poster%20key%20art%2C%20programmer%20silhouette%20in%20a%20dark%20room%20facing%20walls%20of%20glowing%20code%2C%20cool%20blue%20and%20cyan%20light%2C%20high-tech%20cinematic%20atmosphere%2C%20professional%20drama%20poster%2C%20high%20detail&width=400&height=600&seq=vid-13-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20dark%20server%20room%20with%20rows%20of%20glowing%20screens%20and%20cool%20blue%20light%2C%20high-tech%20cinematic%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-13-back&orientation=landscape",
    featured: false,
  },
  {
    id: "jiangcheng-wangshi",
    title: "江城往事",
    type: "tv",
    year: 2023,
    region: "中国",
    genres: ["年代", "家庭"],
    rating: 8.5,
    director: "沈建国",
    actors: ["王秀兰", "李国栋", "张明"],
    status: "已完结",
    episodes: "全38集",
    updateDate: "2023-12-01",
    views: 9400000,
    synopsis:
      "从上世纪八十年代的老工业城讲起，一个普通工人家庭在时代变迁中经历的聚散离合。三十年的风雨，写就一部平凡人的成长史诗。",
    cover:
      "https://readdy.ai/api/search-image?query=Period%20drama%20poster%20key%20art%2C%20old%20riverside%20town%20in%20the%201980s%2C%20nostalgic%20lanes%20and%20river%20boats%2C%20warm%20sepia%20tones%20and%20soft%20haze%2C%20emotional%20cinematic%20mood%2C%20professional%20drama%20poster%2C%20high%20detail&width=400&height=600&seq=vid-14-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20nostalgic%20riverside%20old%20town%20in%20warm%20sepia%20haze%2C%20wooden%20boats%20and%20lanes%2C%20melancholic%20cinematic%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-14-back&orientation=landscape",
    featured: false,
  },
  {
    id: "wuye-yiyuan",
    title: "午夜医院",
    type: "tv",
    year: 2024,
    region: "日本",
    genres: ["惊悚", "悬疑"],
    rating: 7.8,
    director: "山田彻",
    actors: ["高桥优", "松本奈"],
    status: "连载中",
    episodes: "更新至9集",
    updateDate: "2024-10-05",
    views: 3900000,
    synopsis:
      "一名值夜班的年轻护士，发现医院里总有一些无法用常理解释的现象。随着线索逐渐清晰，一段被遗忘的往事重新浮现在走廊尽头。",
    cover:
      "https://readdy.ai/api/search-image?query=Horror%20thriller%20poster%20key%20art%2C%20empty%20hospital%20corridor%20at%20midnight%20with%20flickering%20lights%2C%20a%20lone%20figure%20at%20the%20far%20end%2C%20cold%20green%20tones%20and%20deep%20shadows%2C%20eerie%20cinematic%20atmosphere%2C%20professional%20poster%2C%20high%20detail&width=400&height=600&seq=vid-15-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20dim%20hospital%20corridor%20at%20midnight%20with%20flickering%20lights%20and%20empty%20gurneys%2C%20eerie%20cold%20cinematic%20horror%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-15-back&orientation=landscape",
    featured: false,
  },
  {
    id: "tade-dier-rensheng",
    title: "她的第二人生",
    type: "tv",
    year: 2024,
    region: "中国",
    genres: ["都市", "励志"],
    rating: 8.2,
    director: "林薇",
    actors: ["柳青", "何俊", "苏娜"],
    status: "连载中",
    episodes: "更新至24集",
    updateDate: "2024-10-12",
    views: 7200000,
    synopsis:
      "三十五岁的她在事业与家庭的十字路口选择重新出发。从零开始创业，面对质疑与挫折，她一步步证明：人生任何时候都可以重启。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20drama%20poster%20key%20art%2C%20confident%20young%20woman%20in%20a%20bright%20office%20overlooking%20a%20city%20skyline%2C%20warm%20natural%20light%2C%20aspirational%20elegant%20mood%2C%20professional%20drama%20poster%2C%20high%20detail&width=400&height=600&seq=vid-16-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20bright%20modern%20office%20with%20a%20city%20skyline%20view%20at%20daytime%2C%20warm%20natural%20light%2C%20aspirational%20cinematic%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-16-back&orientation=landscape",
    featured: false,
  },
  {
    id: "kuaile-xingqiu",
    title: "快乐星球大冒险",
    type: "variety",
    year: 2024,
    region: "中国",
    genres: ["真人秀", "亲子"],
    rating: 8.1,
    director: "超级星球工作室",
    actors: ["主持人 乐乐", "嘉宾团"],
    status: "已完结",
    episodes: "全12期",
    updateDate: "2024-08-25",
    views: 8100000,
    synopsis:
      "一档面向全家的户外闯关真人秀，嘉宾们组成战队，在充满创意与欢笑的关卡中比拼默契，传递快乐与陪伴的力量。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20variety%20show%20poster%2C%20playful%20family%20entertainment%2C%20colorful%20balloons%20and%20a%20cheerful%20outdoor%20stage%2C%20warm%20sunshine%20and%20confetti%2C%20lively%20festive%20atmosphere%2C%20professional%20promo%20poster%2C%20high%20detail&width=400&height=600&seq=vid-17-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20colorful%20outdoor%20variety%20show%20stage%20with%20balloons%20and%20confetti%2C%20bright%20festive%20daytime%20atmosphere%2C%20professional%20promo%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-17-back&orientation=landscape",
    featured: false,
  },
  {
    id: "quanmin-geshou",
    title: "全民歌手",
    type: "variety",
    year: 2024,
    region: "中国",
    genres: ["音乐", "选秀"],
    rating: 8.4,
    director: "星声制作",
    actors: ["导师 陈默", "导师 周悦"],
    status: "连载中",
    episodes: "更新至8期",
    updateDate: "2024-10-11",
    views: 15600000,
    synopsis:
      "一档面向所有热爱歌唱的人的音乐舞台。来自不同背景的选手同台竞技，用歌声讲述自己的故事，向梦想与舞台尽情发声。",
    cover:
      "https://readdy.ai/api/search-image?query=Music%20singing%20competition%20poster%2C%20dramatic%20concert%20stage%20with%20spotlights%20and%20a%20microphone%20center%20focus%2C%20glowing%20crowd%20silhouettes%2C%20vibrant%20amber%20and%20crimson%20stage%20lights%2C%20energetic%20show%20atmosphere%2C%20professional%20promo%20poster%2C%20high%20detail&width=400&height=600&seq=vid-18-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20concert%20stage%20with%20warm%20amber%20spotlights%20and%20a%20glowing%20crowd%2C%20energetic%20music%20show%20atmosphere%2C%20professional%20promo%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-18-back&orientation=landscape",
    featured: true,
  },
  {
    id: "jixian-tiaozhan",
    title: "极限挑战营",
    type: "variety",
    year: 2023,
    region: "中国",
    genres: ["竞技", "真人秀"],
    rating: 7.9,
    director: "挑战工场",
    actors: ["队长 阿峰", "嘉宾团"],
    status: "已完结",
    episodes: "全14期",
    updateDate: "2023-10-18",
    views: 6800000,
    synopsis:
      "嘉宾们深入荒野与极限场地，完成一项项考验体力与智慧的任务。在汗水与协作中，展现坚持的力量与团队的温度。",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20competition%20variety%20poster%2C%20contestants%20racing%20through%20a%20rugged%20obstacle%20course%2C%20dynamic%20action%2C%20sunny%20blue%20sky%20and%20dusty%20ground%2C%20energetic%20adventurous%20mood%2C%20professional%20promo%20poster%2C%20high%20detail&width=400&height=600&seq=vid-19-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20outdoor%20obstacle%20course%20under%20a%20sunny%20sky%2C%20contestants%20running%20with%20dust%20in%20the%20air%2C%20energetic%20competitive%20atmosphere%2C%20professional%20promo%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-19-back&orientation=landscape",
    featured: false,
  },
  {
    id: "shenye-tuokouxiu",
    title: "深夜脱口秀",
    type: "variety",
    year: 2024,
    region: "美国",
    genres: ["脱口秀", "喜剧"],
    rating: 8.7,
    director: "杰克·墨菲",
    actors: ["主持人 丹尼"],
    status: "连载中",
    episodes: "更新至22期",
    updateDate: "2024-10-09",
    views: 5900000,
    synopsis:
      "一档轻松幽默的深夜脱口秀，每期邀请不同的嘉宾聊生活、聊热点，在笑声中分享真实又温暖的观察。",
    cover:
      "https://readdy.ai/api/search-image?query=Late%20night%20talk%20show%20poster%2C%20cozy%20studio%20set%20with%20a%20desk%20and%20microphone%2C%20warm%20spotlight%20and%20city%20skyline%20backdrop%2C%20humorous%20inviting%20atmosphere%2C%20professional%20promo%20poster%2C%20high%20detail&width=400&height=600&seq=vid-20-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20late%20night%20talk%20show%20studio%20with%20sofa%20and%20city%20skyline%20backdrop%2C%20cozy%20cinematic%20lighting%2C%20professional%20promo%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-20-back&orientation=landscape",
    featured: false,
  },
  {
    id: "chufang-de-mimi",
    title: "厨房的秘密",
    type: "variety",
    year: 2023,
    region: "日本",
    genres: ["美食", "纪实"],
    rating: 8.3,
    director: "佐藤和也",
    actors: ["主厨 铃木", "旁白 田中"],
    status: "已完结",
    episodes: "全10期",
    updateDate: "2023-09-27",
    views: 3400000,
    synopsis:
      "走进不同城市的小小厨房，记录一道道家常菜背后的手艺与心意。在烟火气中，品味食物与人的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Cooking%20documentary%20poster%2C%20elegant%20kitchen%20with%20fresh%20ingredients%20and%20a%20steaming%20dish%2C%20warm%20soft%20light%2C%20appetizing%20clean%20composition%2C%20professional%20promo%20poster%2C%20high%20detail&width=400&height=600&seq=vid-21-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20warm%20rustic%20kitchen%20with%20fresh%20ingredients%20and%20steaming%20dishes%2C%20cozy%20appetizing%20cinematic%20atmosphere%2C%20high%20detail&width=1280&height=720&seq=vid-21-back&orientation=landscape",
    featured: false,
  },
  {
    id: "lvxing-ba-shaonian",
    title: "旅行吧少年",
    type: "variety",
    year: 2024,
    region: "韩国",
    genres: ["真人秀", "旅行"],
    rating: 8.0,
    director: "金河俊",
    actors: ["嘉宾团"],
    status: "连载中",
    episodes: "更新至6期",
    updateDate: "2024-10-07",
    views: 4700000,
    synopsis:
      "一群年轻人背上行囊，用最朴素的方式走遍山川与海岸。没有剧本，只有真实的相遇、欢笑与成长。",
    cover:
      "https://readdy.ai/api/search-image?query=Travel%20reality%20show%20poster%2C%20young%20travelers%20with%20backpacks%20on%20a%20scenic%20coastal%20road%2C%20golden%20sunset%20and%20open%20sky%2C%20adventurous%20joyful%20mood%2C%20professional%20promo%20poster%2C%20high%20detail&width=400&height=600&seq=vid-22-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20scenic%20coastal%20road%20at%20golden%20sunset%20with%20travelers%20and%20open%20sky%2C%20adventurous%20cinematic%20atmosphere%2C%20professional%20promo%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-22-back&orientation=landscape",
    featured: false,
  },
  {
    id: "wutai-zhiwang",
    title: "舞台之王",
    type: "variety",
    year: 2024,
    region: "中国",
    genres: ["选秀", "音乐"],
    rating: 8.6,
    director: "巅峰视觉",
    actors: ["导师 高源", "导师 叶童"],
    status: "连载中",
    episodes: "更新至10期",
    updateDate: "2024-10-13",
    views: 12300000,
    synopsis:
      "一场以舞台表现力为核心的竞演节目，选手们不断突破自我，用创意与汗水点燃每一场演出，只为成为聚光灯下的焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=Talent%20show%20poster%2C%20dazzling%20performance%20stage%20with%20laser%20beams%20and%20a%20solo%20performer%2C%20vibrant%20gold%20and%20red%20lighting%2C%20thrilling%20competitive%20atmosphere%2C%20professional%20promo%20poster%2C%20high%20detail&width=400&height=600&seq=vid-23-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20dazzling%20performance%20stage%20with%20gold%20and%20red%20laser%20beams%20and%20a%20silhouetted%20performer%2C%20thrilling%20competitive%20show%20atmosphere%2C%20professional%20promo%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-23-back&orientation=landscape",
    featured: false,
  },
  {
    id: "qisi-miaoxiang",
    title: "奇思妙想实验室",
    type: "variety",
    year: 2023,
    region: "英国",
    genres: ["科普", "纪实"],
    rating: 8.8,
    director: "爱丽丝·格林",
    actors: ["主持人 莱恩"],
    status: "已完结",
    episodes: "全9期",
    updateDate: "2023-06-30",
    views: 2900000,
    synopsis:
      "用有趣的小实验和生动的讲解，把身边随处可见的科学原理变得简单好玩。适合全家一起观看的好奇心之旅。",
    cover:
      "https://readdy.ai/api/search-image?query=Science%20variety%20poster%2C%20cheerful%20laboratory%20filled%20with%20colorful%20experiments%20and%20floating%20bubbles%2C%20bright%20clean%20lighting%2C%20curious%20playful%20mood%2C%20professional%20promo%20poster%2C%20high%20detail&width=400&height=600&seq=vid-24-cover&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20bright%20playful%20science%20lab%20with%20colorful%20experiments%20and%20bubbles%2C%20curious%20cheerful%20atmosphere%2C%20professional%20promo%20backdrop%2C%20high%20detail&width=1280&height=720&seq=vid-24-back&orientation=landscape",
    featured: false,
  },
];